import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './review.css';

const reviews = [
  {
    name: 'Manish Choudhary',
    content:
      'I had a medical emergency at home and needed funds urgently. Dhanwalle came to my rescue with a quick loan. The process was easy, the team guided me at every step, and I didn’t have to run around with documents. Really grateful for their support.!',
    icon: 'M',
  },
  {
    name: 'Divya Kapoor',
    content:
      'Vanshika Micro Credit has been a blessing for women like me who wanted to start something small on our own. I got the loan without too much hassle, and the repayment plan was explained very clearly. Their staff was encouraging and supportive.!',
    icon: 'D',
  },
  {
    name: 'Karan Malhotra',
    content:
      'I chose Dhanwalle for a small personal loan, and it turned out to be one of the best financial decisions. Within 24 hours, the money was in my account, without hidden charges or stress. Highly recommended for quick financial needs!',
    icon: 'K',
  },
  {
    name: 'Ritu Agarwal',
    content:
      'I used my Dhanwalle loan to pay my child’s school fees. The quick disbursal and flexible repayment plan really reduced my financial stress. Their support team guided me at every step, making the whole process smooth and worry-free.Truly a dependable service.!',
    icon: 'R',
  },
  {
    name: 'Arvind Tiwari',
    content:
      'I loved how transparent Dhanwalle was. They explained everything clearly about interest, repayment dates, and penalties right from the start. There were no hidden charges or surprises, which built my trust and made the overall experience smooth and positive.',
    icon: 'A',
  },

   {
    name: 'Shalini Deshmukh',
    content:
      'Dhanwalle has a very customer-friendly team. They even sent me reminders politely, unlike the harassing tone used by other lenders. This respectful approach built my trust and made all the difference in my overall loan experience.',
    icon: 'S',
  },

   {
    name: 'Deepak Bansal',
    content:
      'Thanks to Vanshika Micro Credit, I could manage my household expenses independently, without borrowing from friends or relatives. This not only eased my financial burden but also gave me dignity and self-confidence—something truly priceless in life.',
    icon: 'D',
  },

   {
    name: 'Anjali Jha',
    content:
      'Vanshika Micro Credit provided a loan with a reasonable interest rate and a repayment plan perfectly aligned with my salary cycle. Their patient and supportive customer service made the entire process smooth, convenient, and completely stress-free',
    icon: 'A',
  },

   {
    name: 'Vikas Rawat',
    content:
      'I contacted Dhanwalle late on a Friday, not expecting approval before Monday. To my surprise, they disbursed the loan the same day, which was incredibly convenient. The interest rate was fair, and their support team followed up gently and politely.',
    icon: 'V',
  },

   {
    name: 'Harish Chauhan',
    content:
      'Dhanwalle’s loan gave me complete peace of mind. Their system was fast, the interest affordable, and the repayment schedule flexible. With their helpful team and transparent process, I genuinely see them as a reliable and trustworthy financial partner.!',
    icon: 'H',
  },

   {
    name: 'Jyoti Saxena',
    content:
      'I really liked that Vanshika Micro Credit didn’t have any hidden charges. Everything was completely honest and upfront, which is very rare these days. On top of that, their customer service is truly one of the best I have ever experienced.!',
    icon: 'J',
  },
];


const Review = () => {
  return (
    <section className="review-section py-5">
      <div className="container text-center mb-4">
        <h2 className="fw-bold display-5 text-review-heading">WHAT OUR CUSTOMERS SAY</h2>
        <p className="review-subtitle">← Scroll to see more Reviews →</p>
      </div>

      <div className="container position-relative">
        <div className="swiper-button-prev custom-nav"></div>
        <div className="swiper-button-next custom-nav"></div>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="card review-card h-100 p-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="review-avatar me-3">{review.icon}</div>
                  <div>
                    <h6 className="mb-0 fw-bold text-dark">{review.name}</h6>
                    <small className="text-muted">{review.title}</small>
                  </div>
                </div>
                <div className="text-warning mb-2">★★★★★</div>
                <p className="fst-italic mb-0 text-dark">"{review.content}"</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Review;
